(function(){
  function init(){
    var vids = [].slice.call(document.querySelectorAll('.cz video'));
    if (!vids.length) return;
    vids.forEach(function(v){
      v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true;
      v.setAttribute('muted',''); v.setAttribute('playsinline',''); v.setAttribute('webkit-playsinline',''); v.setAttribute('autoplay','');
      v.removeAttribute('controls');
      if (v.preload === 'none') v.preload = 'metadata';
    });
    function allowed(v){ var s = v.closest('.cz-slide'); return !s || s.classList.contains('is-active'); }
    function tryPlay(v){ if (allowed(v) && v.paused){ var p = v.play(); if (p && p.catch) p.catch(function(){}); } }
    function inView(v){ var r = v.getBoundingClientRect(); return r.bottom > 0 && r.top < window.innerHeight; }
    if ('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if (e.isIntersecting) tryPlay(e.target); else e.target.pause(); });
      }, { threshold: 0.2 });
      vids.forEach(function(v){ io.observe(v); });
    } else { vids.forEach(tryPlay); }
    function kick(){ vids.forEach(function(v){ if (inView(v)) tryPlay(v); }); }
    ['touchstart','click','scroll','keydown'].forEach(function(ev){ window.addEventListener(ev, kick, { passive: true, once: true }); });
    document.addEventListener('visibilitychange', function(){ if (!document.hidden) kick(); });
    setTimeout(kick, 600);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
